/* global
    $:true,
    _:true,
    Backbone:true,
    Rover:true
*/

(function() {
  Rover = Rover || {};
  Rover.views = Rover.views || {};

  const HeaderNavBarView = Backbone.View.extend({
    el: '.js-header-navbar',

    initialize() {
      this.$ourServices = $('.js-our-services--dropdown');
      // Set data-qa-id for testing
      this.$ourServices
        .find('a')
        .first()
        .attr('data-qa-id', 'home-links-dog-boarding');
    },

    events: {
      'click .js-show-our-services': 'toggleAllServices',
    },

    toggleAllServices(e) {
      $('.js-how-it-works').removeClass('in');

      e.preventDefault();
      if (this.$el.hasClass('show-all-services')) {
        this.hideAllServices();
      } else {
        this.showAllServices();
      }
    },

    showAllServices() {
      this.$el.addClass('show-all-services');
      this.$ourServices.css('transform', `translateY(${$('.js-header-navbar').outerHeight()}px)`);
    },

    hideAllServices() {
      this.$el.removeClass('show-all-services');
      this.$ourServices.css('transform', 'translateY(-100%)');
    },
  });
  Rover.views.HeaderNavBarView = new HeaderNavBarView();
})();



// WEBPACK FOOTER //
// ./js/components/header_navbar.js